export default __webpack_public_path__ + "static/media/l1-p4.a85a3ce6.svg";